import { MonthlyInstallmentType } from '~domain/helper/premiums/installment/installment-types';
import { TranslationKeys } from '~frontend-common/i18n/english/pad-payment.i18n';

const keys: TranslationKeys = {
  padPayment: {
    flinksPayment: {
      default: {
        subtitle: 'Configurez vos paiements instantanément',
        title: 'Choisissez votre banque',
      },
      consent: {
        title: 'Connectez-vous à votre institution',
        desc: 'YouSet utilise Flinks pour configurer instantanément des paiements mensuels automatiques depuis votre compte bancaire. Flinks fournira à YouSet:',
        itemName: 'Votre nom et vos coordonnées',
        itemAccount: 'Des informations sur votre compte (ex: numéro de compte/transit et solde)',
        cancel: 'Vous pouvez demander à retirer cette connexion à tout moment.',
        action: 'Continuer',
      },
      error: {
        title: "Quelque chose s'est produit. <0>Cliquez ici</0> pour réessayer!",
      },
      success: {
        title: 'Connexion réussie! Cliquez sur <0> Confirmer </0> pour finaliser votre commande.',
      },
      waitingForConnection: 'Connexion en cours',
    },
    mainSubtitle: {
      monthly: 'Configurez les paiements mensuels automatiques à partir de votre compte chèque.',
      yearly: 'Configurez un paiement unique annuellement à partir de votre compte chèque.',
    },
    mainTitle: 'Paiement',
    manualPayment: {
      accountHolderName: 'Nom du détenteur du compte',
      accountNumber: 'Numéro de compte',
      helper: {
        accountNumberLegend:
          'Le deuxième ensemble de chiffres (entre 7 et 12 chiffres) représente votre <0>numéro de compte</0>.',
        bankAccountStatement: '<0>Relevé de compte bancaire</0>',
        bankAccountStatementAccount: 'Votre <0>numéro de compte</0> est un numéro de 7 à 12 chiffres.',
        bankAccountStatementDescription:
          'Vous pouvez trouver les numéros sur le relevé de compte de votre banque ou sur votre compte en ligne.',
        bankAccountStatementTransit: 'Votre <0>numéro de transit</0> est un numéro à 5 chiffres.',
        specimenCheque: '<0>Spécimen de chèque</0>',
        title: 'Où puis-je trouver cette info?',
        transitNumberLegend: 'Les 5 premiers chiffres représentent votre <0>numéro de transit</0>.',
      },
      institutionNumber: 'Banque',
      transitNumber: 'Numéro de transit',
    },
    manualPaymentOption: '<0>Entrer infos bancaires manuellement</0>',
    previousPolicyNumber: {
      car: 'Numéro de police automobile actuel',
      home: 'Numéro de police habitation actuel',
    },
    withCarrier: 'Chez {{0}}',
    prompts: {
      errorPrompt: {
        message: {
          payment:
            'Pour confirmer votre commande, vous devez entrer les informations de votre compte bancaire. Cliquez sur <0>Choisissez votre banque</0> ou <0>Entrer infos bancaires manuellement</0>.',
          previousPolicyNumber:
            'Pour confirmer votre commande, vous devez entrer le numéro de votre police actuelle chez {{0}}.',
        },
      },
    },
    secondarySubtitle_one:
      'Pour émettre votre nouvelle police, nous avons besoin de votre numéro de police actuelle chez {{0}}. S’il-vous-plaît attendre d’avoir reçu votre nouvelle police avant d’annuler.',
    secondarySubtitle_other:
      'Pour émettre vos nouvelles polices, nous avons besoin de vos numéros de polices actuelles avec {{0}}. S’il-vous-plaît attendre d’avoir reçu vos nouvelles polices avant d’annuler.',
    security: 'Paiement Sécurisé Assuré',
    paymentDetails: {
      title: 'Détails de paiement',
      monthly: {
        paymentDate: 'Premier paiement le {{0}}',
        evenlyDistributed: {
          price: '{{0}} / mois',
        },
        [MonthlyInstallmentType.OneMonthInAdvance]: {
          firstMonthPayment: 'Premier paiement de <0>{{0}}</0>',
          subsequentMonthlyPayments: 'Ensuite 10 paiements de {{0}}',
        },
        [MonthlyInstallmentType.TwoMonthInAdvance]: {
          firstMonthPayment: 'Premier paiement de <0>{{0}}</0>',
          subsequentMonthlyPayments: 'Ensuite 9 paiements de {{0}}',
        },
      },
      yearly: {
        paymentDate: 'Paiement unique le {{0}}',
        price: '{{0}}',
      },
      product: {
        car: 'Assurance auto',
        home: 'Assurance habitation',
      },
    },
  },
};

export default keys;
